import React from 'react'
import {Navigate, useRoutes} from 'react-router-dom'

import {useAuth} from './components/SessionAuth'
import Loading from './components/timeButton/Loading'

// layouts
import DashboardLayout from './layouts/dashboard'
import NewDashboardLayout from './layouts_v2/dashboard'
import LogoOnlyLayout from './layouts/LogoOnlyLayout'
//
import StoreLogin from './pages/StoreLogin'
import StoreRegistration from './pages/StoreRegistration'
import StoreOnboard from './pages/StoreOnboard'
import TrackTime from './pages/TrackTime'
import Login from './pages/Login'
import DemoLogin from 'pages/LoginDemo'
import Onboard from './pages/Onboard'
import StoreReports from './pages/StoreReports'
import StoreDashboard from './pages/StoreDashboard'
import EmployeeDashboard from './pages/EmployeeDashboard'
import Products from './pages/Products'
import Blog from './pages/Blog'
import User from './pages/User'
import UserArchive from './pages/UserArchive'
import TimeAdjustment from './pages/TimeAdjustment'
import Admin from './pages/Admin'
import Subscription from './pages/Subscription'
import Store from './pages/Store'
import StoreDetails from './pages/StoreDetails'
import NotFound from './pages/Page404'
import StoreMissing from './pages/StoreMissing'
import StoreQR from './pages/StoreQR'
import StoreProfile from 'pages/StoreProfile'
import StoreBranches from 'pages/StoreBranches'
import Schedule from 'pages/Schedule'
import Announcements from 'pages/Announcements'

// import VideoTutorial from 'pages/VideoTutorial'
import RequiredDocuments from 'pages/StoreRequiredDocuments'
import EmployeeRequiredDocuments from 'pages/EmployeeRequiredDocuments'
import EmployeeRegistration from './pages/EmployeeRegistration.js'
import BreaklistInfo from './pages/BreaklistInfo.js'
import ManageBreaklist from './pages/ManageBreaklist.js'
import Breaklist from './pages/Breaklist.js'
import StoreApproval from './pages/StoreApproval.js'
import GroupRegistration from './pages/GroupRegistration'
import Feedbacks from './pages/Feedback'
import EmployeeProfile from 'pages/EmployeeProfile'
import MyCompany from 'pages/employee-company'
import AdminCompany from 'pages/AdminCompany'
import EmployeeMyHistory from 'pages/EmployeeMyHistory'
import QrScanTimeKeep from 'pages/QrScanTimeKeep'
import AdminActionLogs from 'pages/AdminActionLogs'
import Holidays from 'pages/Holiday'
import AdminTrainingAndDevelopment from 'pages/AdminTrainingAndDevelopment'
import AdminDiceGame from 'pages/AdminDiceGame'
// ----------------------------------------------------------------------

import NewEmployeeDashboard from './pages_v2/EmployeeDashboard'
import NewEmployeeProfile from 'pages_v2/EmployeeProfile'
import NewEmployeeRequiredDocuments from 'pages_v2/EmployeeRequiredDocuments'
import NewMyCompany from 'pages/employee-company'
import NewEmployeeMyHistory from 'pages_v2/EmployeeMyHistory'

import NewUser from './pages_v2/User'
import NewUserArchive from './pages_v2/UserArchive'
import NewTimeAdjustment from './pages_v2/TimeAdjustment'
import NewAdmin from './pages_v2/Admin'
import NewSubscription from './pages_v2/Subscription'
import NewStoreQR from 'pages_v2/StoreQR'
import NewStoreBranches from 'pages_v2/StoreBranches'
import NewStoreDashboard from './pages_v2/StoreDashboard'
import NewStoreReports from './pages_v2/StoreReports'
import NewStore from './pages_v2/Store'
import NewStoreDetails from './pages_v2/StoreDetails'
import NewProducts from './pages_v2/Products'
import NewBlog from './pages_v2/Blog'
import NewStoreProfile from './pages_v2/StoreProfile'
import NewSchedule from './pages_v2/Schedule'
import NewAnnouncements from './pages_v2/Announcements'
import NewBreaklistInfo from './pages_v2/BreaklistInfo'
import NewBreaklist from './pages_v2/Breaklist'
import NewManageBreaklist from './pages_v2/ManageBreaklist'
import NewStoreApproval from './pages_v2/StoreApproval'
import NewRequiredDocuments from './pages_v2/StoreRequiredDocuments'
import NewAdminCompany from './pages_v2/AdminCompany'
import NewFeedbacks from './pages_v2/Feedback'
import NewAdminActionLogs from './pages_v2/AdminActionLogs'
import NewQrScanTimeKeep from './pages_v2/QrScanTimeKeep'
import NewHolidays from './pages_v2/Holiday'
import NewArchivedGate from './pages_v2/ArchivedGate'
import {getAuthPages} from './pageMapper'

const AppRoute = () => {
  const {isAuthenticated, userData, isLoading} = useAuth()
  const uiVersion = localStorage.getItem('uiVersion') || 'old'
  console.log('🚀 ~ AppRoute ~ uiVersion:', uiVersion)
  const {LoginPage, StoreLoginPage, StoreRegistrationPage} = getAuthPages(uiVersion)

  const EmployeeDashboardPage = uiVersion === 'new' ? NewEmployeeDashboard : EmployeeDashboard
  const EmployeeProfilePage = uiVersion === 'new' ? NewEmployeeProfile : EmployeeProfile
  const EmployeeRequiredDocumentsPage = uiVersion === 'new' ? NewEmployeeRequiredDocuments : EmployeeRequiredDocuments
  const MyCompanyPage = uiVersion === 'new' ? NewMyCompany : MyCompany
  const EmployeeMyHistoryPage = uiVersion === 'new' ? NewEmployeeMyHistory : EmployeeMyHistory

  const StoreDashboardPage = uiVersion === 'new' ? NewStoreDashboard : StoreDashboard
  const AdminPage = uiVersion === 'new' ? NewAdmin : Admin
  const TimeAdjustmentPage = uiVersion === 'new' ? NewTimeAdjustment : TimeAdjustment
  const UserPage = uiVersion === 'new' ? NewUser : User
  const UserArchivePage = uiVersion === 'new' ? NewUserArchive : UserArchive
  const SubscriptionPage = uiVersion === 'new' ? NewSubscription : Subscription
  const StoreQRPage = uiVersion === 'new' ? NewStoreQR : StoreQR
  const StoreReportsPage = uiVersion === 'new' ? NewStoreReports : StoreReports
  const StoreBranchesPage = uiVersion === 'new' ? NewStoreBranches : StoreBranches
  const StorePage = uiVersion === 'new' ? NewStore : Store
  const StoreDetailsPage = uiVersion === 'new' ? NewStoreDetails : StoreDetails
  const ProductsPage = uiVersion === 'new' ? NewProducts : Products
  const BlogPage = uiVersion === 'new' ? NewBlog : Blog
  const StoreProfilePage = uiVersion === 'new' ? NewStoreProfile : StoreProfile
  const SchedulePage = uiVersion === 'new' ? NewSchedule : Schedule
  const AnnouncementsPage = uiVersion === 'new' ? NewAnnouncements : Announcements
  const BreaklistInfoPage = uiVersion === 'new' ? NewBreaklistInfo : BreaklistInfo
  const BreaklistPage = uiVersion === 'new' ? NewBreaklist : Breaklist
  const ManageBreaklistPage = uiVersion === 'new' ? NewManageBreaklist : ManageBreaklist
  const StoreApprovalPage = uiVersion === 'new' ? NewStoreApproval : StoreApproval
  const RequiredDocumentsPage = uiVersion === 'new' ? NewRequiredDocuments : RequiredDocuments
  const AdminCompanyPage = uiVersion === 'new' ? NewAdminCompany : AdminCompany
  const FeedbacksPage = uiVersion === 'new' ? NewFeedbacks : Feedbacks
  const AdminActionLogsPage = uiVersion === 'new' ? NewAdminActionLogs : AdminActionLogs
  const QrScanTimeKeepPage = uiVersion === 'new' ? NewQrScanTimeKeep : QrScanTimeKeep
  const HolidaysPage = uiVersion === 'new' ? NewHolidays : Holidays
  const ArchivedGatePage = NewArchivedGate

  // Helper function to safely get user role with fallback
  const getUserRole = () => {
    if (!userData || typeof userData !== 'object') {
      return 0 // Default to employee role
    }

    if (typeof userData.role === 'undefined' || userData.role === null) {
      return 0 // Default to employee role
    }

    return userData.role
  }

  // Helper function to determine dashboard path
  const getDashboardPath = () => {
    const userRole = getUserRole()
    return userRole === 0 ? '/dashboard/app' : '/stores/app'
  }

  return useRoutes([
    {
      // signed in as employee
      path: 'dashboard',
      element: uiVersion === 'new' ? <NewDashboardLayout /> : <DashboardLayout />,
      children: [
        {path: '', element: <Navigate to="app" replace />},
        {path: 'app', element: <EmployeeDashboardPage />},
        {path: 'employee/app', element: <EmployeeDashboardPage />},
        {path: 'app/profile', element: <EmployeeProfilePage />},
        {path: 'app/required-documents', element: <EmployeeRequiredDocumentsPage />},
        {path: 'app/my-company', element: <MyCompanyPage />},
        {path: 'app/my-history', element: <EmployeeMyHistoryPage />},
      ],
    },
    {
      // signed in as store
      path: 'stores',
      element: uiVersion === 'new' ? <NewDashboardLayout /> : <DashboardLayout />,
      children: [
        {path: '', element: <Navigate to="app" replace />},
        {path: 'app', element: <StoreDashboardPage />},
        {path: 'user', element: <UserPage />},
        {path: 'archive', element: <UserArchivePage />},
        {path: 'adjustment', element: <TimeAdjustmentPage />},
        {path: 'admin', element: <AdminPage />},
        {path: 'features', element: <SubscriptionPage />},
        {path: 'qr', element: <StoreQRPage />},
        {path: 'reports', element: <StoreReportsPage />},
        {path: 'branches', element: <StoreBranchesPage />},
        {path: 'store', element: <StorePage />},
        {path: 'store/view/:id', element: <StoreDetailsPage />},
        {path: 'products', element: <ProductsPage />},
        {path: 'blog', element: <BlogPage />},
        {path: 'profile', element: <StoreProfilePage />},
        {path: 'schedule', element: <SchedulePage />},
        {path: 'announcements', element: <AnnouncementsPage />},
        {path: 'breaklist-info', element: <BreaklistInfoPage />},
        {path: 'breaklist', element: <BreaklistPage />},
        {path: 'manage-breaklist', element: <ManageBreaklistPage />},
        {path: 'approval', element: <StoreApprovalPage />},
        {path: 'required-documents', element: <RequiredDocumentsPage />},
        {path: 'admin-company', element: <AdminCompanyPage />},
        {path: 'feedbacks', element: <FeedbacksPage />},
        {path: 'admin-activity-logs', element: <AdminActionLogsPage />},
        {path: 'biometric', element: <QrScanTimeKeepPage />},
        {path: 'holidays', element: <HolidaysPage />},
        {path: 'training-development', element: <AdminTrainingAndDevelopment />},
        {path: 'dice-game', element: <AdminDiceGame />},
      ],
    },
    // Login page without any layout wrapper
    uiVersion === 'new'
      ? {
          path: '/',
          children: [
            {
              path: '',
              element: isLoading ? (
                <Loading />
              ) : isAuthenticated && userData ? (
                <Navigate to={getDashboardPath()} replace />
              ) : (
                <Navigate to="login" replace />
              ),
            },
            {path: 'login', element: <LoginPage />},
            {path: 'login/demo', element: <DemoLogin />},
            {path: 'store', element: <StoreLoginPage />},
            {path: 'store/create', element: <StoreRegistrationPage />},
            {path: 'store/onboard', element: <StoreOnboard />},
            {path: ':store/register', element: <EmployeeRegistration />},
            {path: ':store/onboard', element: <Onboard />},
            {path: '404', element: <NotFound />},
            {path: 'undefined', element: <StoreMissing />},
            {path: 'track-time', element: <TrackTime />},
            {path: 'group/create', element: <GroupRegistration />},
            {path: 'archived', element: <ArchivedGatePage />},
          ],
        }
      : {
          path: '/',
          element: <LogoOnlyLayout />,
          children: [
            {
              path: '',
              element: isLoading ? (
                <Loading />
              ) : isAuthenticated && userData ? (
                <Navigate to={getDashboardPath()} replace />
              ) : window.location.pathname.startsWith("/login") ? (
                <LoginPage />
              ) : (
                <Navigate to="login" replace />
              ),
            },
            {path: 'login', element: <LoginPage />},
            {path: 'login/demo', element: <DemoLogin />},
            {path: 'store', element: <StoreLoginPage />},
            {path: 'store/create', element: <StoreRegistrationPage />},
            {path: 'store/onboard', element: <StoreOnboard />},
            {path: ':store/register', element: <EmployeeRegistration />},
            {path: ':store/onboard', element: <Onboard />},
            {path: '404', element: <NotFound />},
            {path: 'undefined', element: <StoreMissing />},
            {path: 'track-time', element: <TrackTime />},
            {path: 'group/create', element: <GroupRegistration />},
            {path: 'archived', element: <ArchivedGatePage />},
          ],
        },
    {
      path: 'undefined',
      element: <LogoOnlyLayout />,
      children: [{path: 'login', element: <Navigate to="/undefined" replace />}],
    },
    {path: '*', element: <Navigate to="/404" replace />},
  ])
}

export default AppRoute
